/**
 * 운영자 콘솔 회사별 계정 목록의 지원 계정 행·운영자 계정 사유 칸 규칙
 * (W6 A6 — 계약 SUPPORT 3 「고객사에 보이는 모습」·support-scope.ts, PERMISSIONS 6, 설계 3-1·3-3, CI-13).
 * Vue·axios 를 들이지 않는 순수 모듈이라 node --test 로 시험한다(`__tests__/accountRows.test.mjs`).
 */

// 계약 supportUsername(): support-certilife-<회사 id> · support-reseller-<회사 id>
const PREFIX_KIND = [
  ["support-certilife-", "CERTILIFE"],
  ["support-reseller-", "RESELLER"],
];

/**
 * 지원 서브 계정 행인지 — 판정은 목록 응답 줄의 support:{kind, label} 만(계약 SUPPORT 3).
 * 이 값으로 수정·삭제·비밀번호 초기화·2차 인증 버튼을 숨긴다(서버도 403 SUPPORT_ACCOUNT_READONLY — 숨김은 편의)
 */
export const isSupportRow = (row) => !!(row && row.support && row.support.kind);

/**
 * 배지 문구. support 칸이 있으면 그 label, 없을 때만 아이디 접두어로 배지만 단다(보안 판정에 쓰지 않음).
 * @returns "서티라이프 지원 계정 · 편집 불가" | "<리셀러명> 지원 계정 · 편집 불가" | ""
 */
export const supportBadge = (row) => {
  if (!row) return "";
  let kind = row.support && row.support.kind;
  let label = row.support && row.support.label;
  if (!kind) {
    const hit = PREFIX_KIND.find(([p]) => String(row.username || "").startsWith(p));
    if (!hit) return "";
    kind = hit[1];
  }
  if (!label) label = kind === "CERTILIFE" ? "서티라이프 지원" : "리셀러 지원";
  // W1 은 label 에 「… 지원 계정 · 편집 불가」 전체를 준다(support-rows.ts supportTag) — 그때는 그대로
  if (label.includes("편집 불가")) return label;
  return `${label.replace(/\s*계정$/, "")} 계정 · 편집 불가`;
};

/** 운영자·리셀러 계정 생성·삭제 사유(계약 PERMISSIONS 6 · CI-13, 서버 W2 — log 동안 없어도 막히지 않음) */
export const STAFF_REASONS = [
  { value: "HIRE", label: "입사" },
  { value: "LEAVE", label: "퇴사" },
  { value: "TRANSFER", label: "전보" },
  { value: "ABSENCE", label: "휴직" },
  { value: "DUTY_CHANGE", label: "업무변경" },
];

/**
 * 요청에 붙일 칸 {reasonCode, hrRef} — 둘 다 선택(배포 날은 main 과 같이 없어도 됨). 적은 칸만 넣고, 하나도 없으면 undefined.
 * 빈 문자열을 보내지 않는다(inapi 생성 DTO 가 IsOptional+IsIn 이라 "" 는 400)
 */
export const staffReasonFields = (reasonCode, hrRef) => {
  const ref = String(hrRef ?? "").trim();
  const out = { ...(reasonCode ? { reasonCode } : {}), ...(ref ? { hrRef: ref } : {}) };
  return Object.keys(out).length ? out : undefined;
};
